import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Components
import { CustomDatesSelectorComponent } from './custom-dates-selector/custom-dates-selector.component';
import { PaymentTermsSelectorComponent } from './payment-terms-selector.component';
import { PaymentPlanInstallmentComponent } from './payment-plan-installment/payment-plan-installment.component';
import { PaymentPlanPreviewComponent } from './payment-plan-preview/payment-plan-preview.component';
import { PaymentTermPreviewComponent } from './payment-term-preview/payment-term-preview.component';
import { PaymentTermSummaryComponent } from './payment-term-summary/payment-term-summary.component';

// Services and Pipes
import { OrdinalDatePipe } from '../shared/pipes/ordinal-date.pipe';
import { SharedModule } from '../app/shared.module';
import { UpfrontPaymentAmountComponent } from './upfront-payment-amount/upfront-payment-amount.component';
import { CurrencyPipe } from '@angular/common';
import { SeFeBlockModule } from 'se-fe-block';
import { SeFeButtonModule } from 'se-fe-button';
import { SeFeIconModule, seFeIconCalendar, seFeIconCalendarToday, seFeIconFlag, seFeIconPlusCircleOutline, seFeIconRemove, seFeIconDollar } from 'se-fe-icon';
import { SeFePopoverModule } from 'se-fe-popover';
import { SeFeSpinnerModule } from 'se-fe-spinner';
import { SeFeTooltipModule } from 'se-fe-tooltip';
import { SeFeGridModule } from 'se-fe-grid';
import { SeFeToolbarModule } from 'se-fe-toolbar';
import { SeFeTableModule } from 'se-fe-table';
import { SeFeServiceModule } from 'se-fe-service';
import { environment } from 'src/environments/environment';
import { SeFeModalModule } from 'se-fe-modal';
import { SeFeEmptyStateModule } from 'se-fe-empty-state';
import { SeFePaginationModule } from 'se-fe-pagination';
import { SeFeDatepickerModule } from 'se-fe-datepicker';
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options';
import { SeFeFormFieldModule } from 'se-fe-form-field';
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text';
import { SeFeFormFieldSelectModule } from 'se-fe-form-field-select';
import { SeFeLinkModule } from 'se-fe-link';
import { SeFeAlertModule } from 'se-fe-alert';

@NgModule({
  declarations: [
    OrdinalDatePipe,
    PaymentTermsSelectorComponent,
    PaymentPlanPreviewComponent,
    PaymentTermPreviewComponent,
    PaymentTermSummaryComponent,
    PaymentPlanInstallmentComponent,
    CustomDatesSelectorComponent,
    UpfrontPaymentAmountComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    SeFeDatepickerModule,
    SeFeFormFieldOptionsModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeFormFieldSelectModule,
    SeFeLinkModule,
    SeFeAlertModule,
    SeFeBlockModule,
    SeFeButtonModule,
    SeFeIconModule.include([ seFeIconCalendar, seFeIconFlag, seFeIconPlusCircleOutline, seFeIconRemove, seFeIconCalendarToday, seFeIconDollar ]),
    SeFePopoverModule,
    SeFeSpinnerModule,
    SeFeTooltipModule,
    SeFeEmptyStateModule,
    SeFeGridModule,
    SeFeModalModule,
    SeFePaginationModule,
    SeFeServiceModule.forRoot({domainEnvironments: environment.domainEnvironments}),
    SeFeTableModule,
    SeFeToolbarModule,
  ],
  providers: [
    CurrencyPipe,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
})

export class PaymentTermsSelectorModule {
  constructor(private injector: Injector) {}

  public ngDoBootstrap() {
    const el = createCustomElement(PaymentTermsSelectorComponent, {injector: this.injector});
    if (!customElements.get('payment-terms-selector-element')) { customElements.define('payment-terms-selector-element', el); }
  }
}
